import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { sendOtp } from '../../api/request/loginThunk';
import { signUp } from '../../api/request/signupThunk'; 

export interface OtpState {
  message: string;
  isLoading: boolean;
  isError: boolean;
  isSuccess:boolean;
  error: string;
}

const initialState: OtpState = {
  message: '',
  isSuccess:false,
  isLoading: false,
  isError: false,
  error: '',
};

const otpSlice = createSlice({
  name: 'otp',
  initialState,
  reducers: {
    resetOtp: (state) => {
      state.message = '';
      state.isError = false;
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendOtp.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = '';
      })
      .addCase(sendOtp.fulfilled, (state, action: PayloadAction<string>) => {
        state.isLoading = false;
        state.isSuccess=true;
        state.message = action.payload; 
      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        const errorMessage = action.payload as string;
        if (/<[a-z][\s\S]*>/i.test(errorMessage)) {
            state.error = "An unexpected error occurred. Please try again later.";
        } else {
            state.error = errorMessage || "Failed to send OTP. Please try again.";
        }
      })

      .addCase(signUp.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = '';
      })
      .addCase(signUp.fulfilled, (state, action: PayloadAction<string>) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload; 
      })
      .addCase(signUp.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        const errorMessage = action.payload as string;
    if (/<[a-z][\s\S]*>/i.test(errorMessage)) {
        state.error = "An unexpected error occurred. Please try again later.";
    } else {
        state.error = errorMessage || "Failed to sign up. Please try again.";
    }
      });
  },
});

export const { resetOtp } = otpSlice.actions;
export default otpSlice.reducer;
